module.exports = __webpack_public_path__ + "img/screen-7.4557e97e.jpg";